export const TRANSACTION_TYPE = [
  'Award',
  'Redeem',
  'Adjust',
  'Refund'
]